import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { apiMethod, apiType, API_URL } from 'utils';
import OrderManagementApiService from './OrderManagementApiService';
import { IPayload } from 'Model/IPayload';
import { GET_APPROVAL_HISTORY_DETAIL_EXCEL_DATA, GET_APPROVAL_HISTORY_REPORT, GET_APPROVAL_HISTORY_REPORT_DETAILS, GET_APPROVAL_HISTORY_REPORT_EXCEL_DATA } from 'Store/OrderManagement/ApprovalHistoryReport/ApprovalHistoryReportType';
import { setApprovalHistoryDetailExcel, setApprovalHistoryReport, setApprovalHistoryReportDetails, setApprovalHistoryReportExcelData } from 'Store/OrderManagement/ApprovalHistoryReport/ApprovalHistoryReportAction';

function* getApprovalHistoryReport(req?: any): any {

    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.OrderManagement,
        endpoint: `approvalmanagement/report/approvalhistory`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Fetching grid details...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setApprovalHistoryReport(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setApprovalHistoryReport([]))
        yield put(globalLoaderText(""));
    }
}

function* getApprovalHistoryReportDetails(req?: any): any {

    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `approvalmanagement/report/detail/approvalhistory/${req?.payload}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching approval history details...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setApprovalHistoryReportDetails(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setApprovalHistoryReportDetails({}))
        yield put(globalLoaderText(""));
    }
}

function* getApprovalHistoryReportExcelData(req?: any): any {

    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.OrderManagement,
        endpoint: `approvalmanagement/report/approvalhistory/export`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Fetching approval history excel...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setApprovalHistoryReportExcelData(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setApprovalHistoryReportExcelData(""))
        yield put(globalLoaderText(""));
    }
}

function* getApprovalHistoryDetailExcelData(req?: any): any {

    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `approvalmanagement/report/details/approvalhistory/export?orderId=${req?.payload}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching approval history excel...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setApprovalHistoryDetailExcel(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setApprovalHistoryDetailExcel(""))
        yield put(globalLoaderText(""));
    }
}

function* watchApprovalHistoryReport() {
    yield takeEvery(GET_APPROVAL_HISTORY_REPORT, getApprovalHistoryReport);
    yield takeEvery(GET_APPROVAL_HISTORY_REPORT_DETAILS, getApprovalHistoryReportDetails);
    yield takeEvery(GET_APPROVAL_HISTORY_REPORT_EXCEL_DATA, getApprovalHistoryReportExcelData);
    yield takeEvery(GET_APPROVAL_HISTORY_DETAIL_EXCEL_DATA, getApprovalHistoryDetailExcelData);
}

export default function* combinedSaga() {
    yield all([
        watchApprovalHistoryReport()
    ])
}
